import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Erro de negócio da API vem como array `[{ msgUsuario, msgDesenvolvedor }]` (W3erpExceptionHandler).
// Mesmo helper local de getOrganizationsLogo — a mensagem do `msgUsuario` é acionável
// ("A data do marco zero não pode ser futura."), e perdê-la para o texto genérico do catchError
// deixaria o super-admin sem saber o que corrigir.
const erroMarcoZero = (error: unknown): { message: string } => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    const msg = Array.isArray(data) ? data[0]?.msgUsuario : undefined
    if (msg) {
      return { message: msg }
    }
  }
  return catchError(error)
}

/**
 * Declara um marco zero novo. É append-only no backend: cada chamada registra uma declaração e a
 * anterior vira trilha — não existe edição nem remoção, de propósito.
 *
 * `dataMarco` vai em ISO `yyyy-MM-dd` (java.sql.Date sem @JsonFormat no DTO), o mesmo formato que
 * volta na resposta. É também o formato nativo do `<input type="date">`, então não há conversão
 * em lugar nenhum do caminho.
 *
 * Devolve a consulta já atualizada (vigente + trilha), evitando um GET em seguida.
 */
export const declararMarcoZero = async (
  id: number,
  dataMarco: string,
  observacao: string
): Promise<GetMarcoZeroConsultaType | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/organizacao/${id}/marco-zero`,
      { dataMarco, observacao: observacao || null }
    )
    return result.data
  } catch (error) {
    return erroMarcoZero(error)
  }
}

/**
 * Marco zero vigente + declarações anteriores.
 *
 * Devolve `null` quando a organização nunca declarou — a API responde **204**, e distinguir isso de
 * uma falha é o que permite a tela dizer "ainda não declarado" em vez de sugerir erro. Mesmo
 * tratamento (e mesma ordem de checagem) do GET da logo.
 */
export const getMarcoZero = async (
  id: number
): Promise<GetMarcoZeroConsultaType | null | { message: string }> => {
  try {
    const result = await apiService.get(`central/organizacao/${id}/marco-zero`)
    if (result.status === 204) {
      return null
    }
    return result.data
  } catch (error) {
    return catchError(error)
  }
}
